export default __webpack_public_path__ + "static/media/kids-playworld.inline.a0f378a2.svg";